module.exports = __webpack_public_path__ + "static/Bomb-d43b68ab313f4ab6b1eb944e048f03d9.svg";